import Immutable from 'immutable';
import { AppStateActionParams } from 'records/AppState';
import { RawPermissions } from 'records/Permissions';
import { Project } from 'records/Project';

// TODO: Figure out how to get rid of the any types, maybe use generics.
export default function permsCheck(
  permsToCheck: string[],
  actionFunc: any
): any {
  return (actionParams: AppStateActionParams, ...rest: any[]): any => {
    const permsToCheckList = Immutable.List(permsToCheck);
    const { selectedProject, projects } = actionParams.state();
    const { permissions } = projects.get(selectedProject, new Project());

    const hasPerms = permsToCheckList.every((p: string): boolean =>
      permissions.get(p as keyof RawPermissions)
    );

    if (!hasPerms) {
      console.log(
        `User does not have required permissions for action: ${actionParams.name}`,
        permsToCheck
      );
      return actionParams.state();
    }

    return actionFunc(actionParams, ...rest);
  };
}
